import { useAuth } from "./useAuth";
import { useStore } from "../state/store";
import { hasBuyerAccess } from "../auth/authService";

export function useAccountGate() {
  const { session } = useAuth();
  const { dispatch } = useStore();
  const allowed = hasBuyerAccess(session?.role);

  function requestAccount(pendingPath) {
    if (pendingPath) {
      dispatch({ type: "SET_PENDING_PATH", payload: pendingPath });
    }
    dispatch({ type: "OPEN_MODAL", payload: "buyerAccount" });
  }

  function gateEvent(event, pendingPath) {
    if (allowed) return false;
    event?.preventDefault();
    event?.stopPropagation();
    requestAccount(pendingPath);
    return true;
  }

  return {
    allowed,
    hasBuyerAccount: session?.role === "buyer" || session?.role === "admin",
    requestAccount,
    gateEvent,
  };
}
